// import { useState } from 'react'
import { RiMenu3Fill } from 'react-icons/ri';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';


export const Nav = styled.nav`
  background: transparent;
  height: 50px;
  display: flex;
  position: absolute;
  padding: 10px 50px;
  margin: 40px 20px;
  z-index: 12;
  /* border: 1px solid black; */
  @media screen and (max-width: 768px) {
      height: 40px;
      padding: 10px 20px;
      margin: 40px 0px;
      justify-content: space-between;
      width: 90%;

      /* flex-flow: column nowrap; */
      /* background-color: #0D2538; */
      /* position: fixed; */
      /* transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'}; */
      /* top: 0; */
      /* right: 0; */
      /* height: 100%;
      margin: 0;
      width: 100%; */
      /* padding-top: 3.5rem; */
  }
`;

export const Bars = styled(RiMenu3Fill)`
  display: none;
  color: red;
  @media screen and (max-width: 768px) {
    display: block;
    transform: translate(0%, 25%);
    transition: all 1s ease;
    font-size: 1.8rem;
    cursor: pointer;
  }
`

// const toggle = () => console.log("hi");

export const NavImg = styled.div`
    display: flex;
`;

export const NavLink = styled(Link)`
  color: #444444;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 2px;
  margin: 0 1rem;
  height: 100%;
  cursor: pointer;
  font-size: 1.2rem;
  &.active{
      font-weight: bold;
      border-bottom: 4px solid red;
      transition: border-bottom 0.1s ease-in-out;
      @media screen and (max-width: 768px) {
        /* border-bottom: none; */
      }
  }
  @media screen and (max-width: 768px) {
    color: white;
    padding-top: 30px;
  }
`;

export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const Menu = styled.div`
  display: none;
  align-items: center;
  @media screen and (max-width: 768px) {
    /* display: none; */
    display: flex;
  }
`;

